export const ENTERPRISE_ROUTES = {
  HOME: '',
  ENTERPRISE_LIST: 'list-enterprises',
};
